import type { ReactNode } from "react";
import { Switch as AriaSwitch, type SwitchProps as AriaSwitchProps } from "react-aria-components";
import { cx } from "../cx.js";
import styles from "./Switch.module.css";

export interface SwitchProps extends Omit<AriaSwitchProps, "className" | "children"> {
  children: ReactNode;
  className?: string;
}

export function Switch({ children, className, ...rest }: SwitchProps) {
  return (
    <AriaSwitch {...rest} className={cx(styles.switch, className)}>
      <span className={styles.track} aria-hidden="true">
        <span className={styles.thumb} />
      </span>
      {children}
    </AriaSwitch>
  );
}
